import React, { useEffect, useState } from "react";

import { AnimatePresence, motion } from "framer-motion";

import { TransitionProposalFlowPageIndex } from "../types";
import { useFlowContainerContext } from "@src/sharedComponents/FlowContainer/reducer/Context";

import Add from "./Add/Add";
import Review from "./Review/Review";
import Share from "./Share/Share";
import Start from "./Start/Start";

import styles from "./TransitionProposalFlowSteps.module.css";

const transitionVariants = {
  initial: { opacity: 0, x: "-20px" },
  animate: {
    opacity: 1,
    x: "0px",
    transition: { duration: 0.3, ease: "easeOut" },
  },
  exit: {
    opacity: 0,
    x: "20px",
    transition: { duration: 0.3, ease: "easeIn" },
  },
};

interface Props {
  header: React.ReactNode;
}

const TransitionProposalFlowSteps: React.FC<Props> = ({ header }) => {
  const {
    state: { pageIndex },
  } = useFlowContainerContext();

  const [hasMounted, setHasMounted] = useState(false);

  useEffect(() => {
    setHasMounted(true);
  }, []);

  return (
    <AnimatePresence exitBeforeEnter={hasMounted}>
      <motion.div
        key={pageIndex}
        variants={transitionVariants}
        initial="initial"
        animate="animate"
        exit={hasMounted ? "exit" : {}}
        className={styles.motionContainer}
      >
        {header}
        {pageIndex === TransitionProposalFlowPageIndex.Start && <Start />}
        {pageIndex === TransitionProposalFlowPageIndex.Add && <Add />}
        {pageIndex === TransitionProposalFlowPageIndex.Review && <Review />}
        {pageIndex === TransitionProposalFlowPageIndex.Share && <Share />}
      </motion.div>
    </AnimatePresence>
  );
};

export default TransitionProposalFlowSteps;
